import { useRef } from "react";
import { Edges } from "@react-three/drei";
import { useThree, useFrame } from '@react-three/fiber'


export function Prism({ onRayOver, onRayOut, onRayMove, ...props }) {
  const refRay = useRef();
  const ref = useRef();

  useFrame(() => {
    const rotation = Math.sin(Date.now() * 0.0005) * Math.PI * 0.0005;
    ref.current.rotation.y += rotation;
    refRay.current.rotation.y += rotation;
  });

  const { width, height } = useThree((state) => state.viewport)
  const cubeLenght = width / 15

  const posMobile = [-0.1* width /2 , 0.2*height / 2, 5]
  const posDesktop = [-0.8* width /2 , - 0.6*height / 2, 5]
  let cubePosition = null;

  if (window.innerWidth <= 768) {
    cubePosition = posMobile
  } else {
    cubePosition = posDesktop
  }


  return (
    <group {...props}>
      {/* A low-res, invisible representation of the prism that gets hit by the raycaster */}
      <mesh
        ref={refRay}
        visible={false}
        scale={8}
        position={[-width /2, - height / 2, 5]}
        rotation={[.3, .6, 0]}
        onRayOver={onRayOver}
        // onRayOut={onRayOut}
        // onRayMove={onRayMove}
      >
        <boxGeometry args={[cubeLenght, cubeLenght, cubeLenght]} />
      </mesh>
      {/* The visible hi-res prism */}
      <mesh
        ref={ref}
        scale={6}
        position={cubePosition}
        rotation={[.3, .6, 0]}
        renderOrder={10}
        dispose={null}
      >
        <boxGeometry args={[cubeLenght, cubeLenght, cubeLenght]} />

        {/* <meshBasicMaterial color="yellow" wireframe /> */}
        <meshPhysicalMaterial
          clearcoat={1}
          clearcoatRoughness={0}
          transmission={1}
          thickness={0.9}
          roughness={0}
          toneMapped={false}
        />
      </mesh>
    </group>
  );
}
